import React from "react";
import { useLocation } from "react-router-dom";
import { ApprovalEmployeeList } from "./ipmsmodel";
import { useManageIPMSContext } from "./ManageIPMSContex";

import AssignManageable from "./assignManagertable";

const AssignManagerForm: React.FC = () => {
  const location = useLocation();
  const { getEmployeequarterAppriserList } = useManageIPMSContext();
  const state = location.state as { item: ApprovalEmployeeList | null } | undefined;
  const employee_id = state?.item ? state?.item?.employeeid ?? "" : "";

  React.useEffect(() => {
    if (employee_id) {
      getEmployeequarterAppriserList({
        searchname: employee_id ? String(employee_id) : "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employee_id]);


  return (
    <div className=' p-4 '>
      <h1 className='text-lg font-semibold text-gray-400 mb-4'>
        Assign Appraiser for {state?.item?.employee_name}
      </h1>
      <AssignManageable employeeId={employee_id ? Number(employee_id) : null} />
    </div>
  );
};

export default AssignManagerForm;
